const styles = theme => ({
    dialogRoot: {
    },
    actionRoot: {
        margin: '16px 8px',
        padding: 0,
        background: theme.palette.background.paper
    },
    message: {
        color: theme.palette.text.primary
    }
});

export default styles;